// Maybe TODO, enforce the correct length and chars of each sub-string
export type Guid = `${string}-${string}-${string}-${string}-${string}`;

export const EmptyGuid: Guid = '00000000-0000-0000-0000-000000000000';

export const guidsAreEqual = (a: Guid, b: Guid) =>
  a?.toLowerCase() === b?.toLowerCase();

export function newGuid() {
  //source: https://gist.github.com/gmilby/6611969
  //alternatives: http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
  function chunk(chunkSize: number) {
    return (Math.random().toString(16) + '0'.repeat(chunkSize)).substring(
      2,
      2 + chunkSize
    );
  }
  const guid = [chunk(8), chunk(4), chunk(4), chunk(4), chunk(12)].join(
    '-'
  ) as Guid;
  return guid;
}
